const colors = ['#ffffff', '#000000'];
export const hexToRGBArray = (hex) => {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? [parseInt(result[1], 16), parseInt(result[2], 16), parseInt(result[3], 16)] : [];
};
export const getLuminance = (hexColor) => {
    // Formula: http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
    const rgbArray = hexToRGBArray(hexColor);
    rgbArray.forEach((item, index) => {
        let color = item / 255;
        color = color < 0.03928 ? color / 12.92 : Math.pow(((color + 0.055) / 1.055), 2.4);
        rgbArray[index] = color;
    });
    return 0.2126 * rgbArray[0] + 0.7152 * rgbArray[1] + 0.0722 * rgbArray[2];
};
export const colorContrast = (color1, color2) => {
    // Formula: http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef
    const luminance1 = getLuminance(color1) + 0.05;
    const luminance2 = getLuminance(color2) + 0.05;
    let ratio = luminance1 / luminance2;
    if (luminance2 > luminance1) {
        ratio = 1 / ratio;
    }
    return ratio;
};
export const getContrastColor = (baseColor, colorList = colors) => {
    let contrastColor = colorList[0];
    let contrast = 0;
    colorList.forEach((color) => {
        const currentContrast = colorContrast(baseColor, color);
        if (currentContrast > contrast) {
            contrastColor = color;
            contrast = currentContrast;
        }
    });
    return contrastColor;
};
export const hexToRgba = (hex, alpha = 1) => {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
        ? `rgba(${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(result[3], 16)}, ${alpha})`
        : null;
};
